module.exports = __webpack_public_path__ + "img/selected4-min.c9b8df48.png";